import { render, staticRenderFns } from "./CustomDeezer.vue?vue&type=template&id=324f6061&"
import script from "./CustomDeezer.vue?vue&type=script&lang=ts&"
export * from "./CustomDeezer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports